import { render, staticRenderFns } from "./ConsensusReviewPanel.vue?vue&type=template&id=ef45f736&scoped=true&"
import script from "./ConsensusReviewPanel.vue?vue&type=script&lang=js&"
export * from "./ConsensusReviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./ConsensusReviewPanel.vue?vue&type=style&index=0&id=ef45f736&lang=scss&scoped=true&"
import style1 from "./ConsensusReviewPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef45f736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
